import { createFileRoute } from '@tanstack/react-router';
import { validateInvoicesSearch } from '@/pages/Invoices/InvoicesPage.config';

// W6.T6.4 gave this route a `page` param so pagination was URL-driven. W4.T6.0 adds the filter
// params, which until now lived in a Zustand store and were pushed to the URL with a raw
// history.replaceState — behind the router, and therefore lost on the next navigate().
export const Route = createFileRoute('/invoices/')({
  validateSearch: validateInvoicesSearch,
});
